module.exports = __webpack_public_path__ + "img/Catching_up_with_Former_CFTC_Chairman_J_Christopher_Giancarlo.3816c901.jpg";